<template>
  <div style="width: 100%;">
    <h3>Communication</h3>
    <el-row style="padding: 5px;">  
      <el-col :span="2"><el-button type="success" @click="addTableData()">{{$t('button.create')}}</el-button></el-col> 
    </el-row>   
    <el-table ref="singleTable" :data="tableData.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')">
      <el-table-column v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
        <template slot-scope="scope">
          <!--
          <span v-if="currentIndex==scope.$index">
            <el-input size="mini" :placeholder="$t('msg.pleaseEnterContent')"  v-model="scope.row[v.field]"></el-input>
          </span>
          -->
          <span v-if="v.field != 'description'">{{ scope.row[v.field] }}</span>
          <span v-else v-html="scope.row.description"></span>

        </template>
      </el-table-column>      
    </el-table>
    <h3>Analysis Report / Software update</h3>
    <FileEditList ref="analysisFiles" :onlyView="lockAnalysisReport" :docId="pFeedbackId" uploadType="feedback" subFolder="analysisReport"  @sync-save-status="syncFileSave"/> <br>

    <el-dialog ref="fileEditDialog" :title="dialogTitle" :visible.sync="dialogVisible" width="50%" :before-close="handleClose" :lock-scroll=true
      :close-on-click-modal=false :close-on-press-escape =false :show-close=false>
      <el-form :model="editForm"  label-width="80px">        
        <el-row>
          <el-col :span="22">
            <el-form-item :label="$t('field.message')" >
              <el-input type="textarea" v-model="editForm.remark" rows="5"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        </el-form>  
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{$t('button.cancel')}}</el-button>
          <el-button type="warning" @click="confirmComment">{{$t('button.confirm')}}</el-button>
        </span>         
    </el-dialog>
  </div>
</template>

<script>
import { apiFindFeedbackCommByFeedbackId, apiSaveFeedbackComm } from "../../../utils/api.js";
import authHeader from "../../../services/auth-header";
import FileEditList from "../FileEditList";
import CommonUtil from "../../../utils/commonUtil.js";
export default {
  props: {    
    pFeedbackId: {
      type: String
    },
    lockAnalysisReport: {
      type: Boolean
    }
  },
  data() {   
    return {    
      dialogVisible: false,
      dialogTitle: '',
      currentIndex:-1,
      tableData: {
        sel: null,
        columns: [   
          { field: "modifyUser", title: this.$i18n.t('field.replyPerson'), width: 200 },         
          { field: "description", title: this.$i18n.t('field.message') },
          { field: "modifyTime", title:this.$i18n.t('field.modifyTime'), width: 180  }
        ],
        data: []
      },
      editForm:{
        remark:''
      }
    };
  }, 
  components: {
    FileEditList
  },
  mounted() {
    if(this.pFeedbackId != null && this.pFeedbackId != ''){      
      this.findData();
    }
  },
  methods: {
    saveAnalysisReport(){
      this.$refs.analysisFiles.save();
    },
    findData(){
      this.tableData.data = [];
      apiFindFeedbackCommByFeedbackId({ headers: authHeader(), feedbackId: this.pFeedbackId}).then((response) => {         
        if(response.status== 200 && response.data != null && response.data.length > 0){
          var reg = new RegExp("<br>","g");
          response.data.forEach((item, index) => { 
            item.modifyTime = CommonUtil.dateFormat(new Date(item.modifyTime ));            
            //item.description = item.description.replace(reg,"\n");
          });
          this.tableData.data = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    addTableData() {
      this.editForm.remark = '';
      this.editForm.action = 'A';
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.$confirm(this.$i18n.t('msg.confirmtoClose'),{
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {          
        this.dialogVisible = false;          
        done();
      }).catch(_ => {});
    },
    confirmComment(){
      if(this.editForm.remark == null || this.editForm.remark == ''){
        return this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
      } else { 
        this.$confirm(this.$i18n.t('msg.confirmSendMessage'),{
          confirmButtonText: this.$i18n.t('button.confirm'),
          cancelButtonText: this.$i18n.t('button.cancel'),
          type: 'warning'
        }).then(_ => {          

          if(!CommonUtil.isNull(this.editForm.remark)){
            this.editForm.remark = this.editForm.remark.replace(/\n|\r\n/g,"<br>");
          }

          apiSaveFeedbackComm({ headers: authHeader(), feedbackComm: {feedbackId:this.pFeedbackId, description:this.editForm.remark, action:'A' }}).then((response) => {             
            if(response.status== 200){              
              this.findData();
            }
          }).catch((err) => {
            console.log(err);
          });
          this.dialogVisible = false;       
          done();
        }).catch(_ => {});


        // var newData = {
        //   action: this.editForm.action == 'A'? 'A': 'U',
        //   description: this.editForm.remark,
        //   account: this.$store.state.auth.user.username,
        //   modifyTime: CommonUtil.dateFormat(new Date())            
        // };    

        // if(this.editForm.action == 'A'){
        //   this.tableData.data.splice(0, 0, newData);
        //   this.tableData.sel = JSON.parse(JSON.stringify(newData)); 
        // } else {
        //   this.$set( this.tableData.data,  this.editFileForm.currentIndex, newData);
        // }
       
         
      }      
    },
    syncFileSave(status){
      this.$emit('sync-cust-comm-file-save', status);
      
    }
  }
};
</script>
<style>
.el-table .cell {
    word-break: break-word;
}
</style>